import { render, staticRenderFns } from "./TheNavbarTopPanelMenu.vue?vue&type=template&id=6508fd4a&scoped=true&"
import script from "./TheNavbarTopPanelMenu.vue?vue&type=script&lang=js&"
export * from "./TheNavbarTopPanelMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508fd4a",
  null
  
)

export default component.exports